export default {
  install(Vue, { router }) {
    router.addRoutes([
      {
        path: '/agreement',
        name: 'Agreement',
        component: () => import('./Agreement.page.vue'),
        props: true,
        meta: {
          title: 'TITLE__AGREEMENT_ADD',
          template: 'Main',
          isAuthentication: true,
        },
        children: [
          {
            path: '/',
            redirect: '/agreement/book',
          },
          {
            path: 'book',
            name: 'AgreementBook',
            component: () => import('./Book/Book.page.vue'),
            props: true,
            meta: {
              title: 'TITLE__AGREEMENT_ADD',
              template: 'Main',
              isAuthentication: true,
            },
          },
        ],
      },
    ]);
  },
};
